module.exports = __webpack_public_path__ + "media/images/icon__breadcrumbs-arrow-left--rb-raven-gray@3x-8ca44e346f714d11588525977d8b7120.png";